import React, { useId } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/**
 * Panel shell used across the IPO dashboard: title row, optional right-hand slot,
 * body and an optional footer link.
 */
export const DashboardCard = ({ title, titleAddon, subtitle, aside, footer, children, className = '' }) => {
  const headingId = useId();
  return (
    <section
      aria-labelledby={headingId}
      className={`bg-white rounded-2xl border border-slate-200/90 shadow-sm overflow-hidden ${className}`}
    >
      <div className="flex flex-wrap items-start justify-between gap-3 px-4 sm:px-5 pt-4 sm:pt-5 pb-3 sm:pb-4">
        <div className="min-w-0">
          <h2 id={headingId} className="flex items-center gap-2 text-base sm:text-lg font-extrabold text-slate-900 tracking-tight">
            {titleAddon}
            {title}
          </h2>
          {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
        </div>
        {aside}
      </div>
      {children}
      {footer && <div className="border-t border-slate-100 px-4 py-3 text-center">{footer}</div>}
    </section>
  );
};

// Footer/aside link: router links for app routes, plain anchors for in-page placeholders
export const DashboardLink = ({ to, children, className = '' }) => {
  const classes = `inline-flex items-center gap-1 text-xs font-bold text-[#008080] hover:text-[#006666] hover:underline ${className}`;
  const content = (
    <>
      {children}
      <ArrowRight className="w-3.5 h-3.5 flex-shrink-0" />
    </>
  );
  return to.startsWith('/') ? (
    <Link to={to} className={classes}>
      {content}
    </Link>
  ) : (
    <a href={to} className={classes}>
      {content}
    </a>
  );
};

export const TABLE_HEAD_CLASS =
  'bg-slate-50/90 border-y border-slate-200/80 text-[11px] font-bold text-slate-500 uppercase tracking-wider';

export default DashboardCard;
